import {useContext} from 'react'

import PropTypes from 'prop-types'

import {htmlStringToReactElement} from '@s-ui/js/lib/react'
import Context from '@s-ui/react-context'
import {useMediaQuery, useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'

const BASE_CLASS_NAME = 'mt-VehicleAppraiserPage'

const RecommendedPriceCard = ({
  fuelId,
  km,
  postalCode,
  versionName,
  year,
  manufacturerPrice,
  roundedRecommendPrice,
  makeName,
  modelName,
  hasRecommendedPriceError,
  c2bAppraisal
}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')

  const urlStaticImages = config.get('URL_STATICS_IMAGES')

  const isMobile = config.get('isMobile')

  const initialMediaQueryMatch = {
    defaultMatches: !isMobile
  }

  const isDesktop = useMediaQuery(useMediaQueryBreakpoints.lg, initialMediaQueryMatch)

  const appName = config.get('APP_NAME').toLowerCase()
  const urlInstantOfferImages = `${urlStaticImages}${appName}/landing/instant-offer/`

  const {FUEL_TYPE_NAME_MAPPING} = config.get('page')

  const vehicleName = `${makeName} ${modelName} ${versionName}`

  const vehicleInformation = `${FUEL_TYPE_NAME_MAPPING[fuelId]} - ${year}  - ${km} km - ${versionName} - CP ${postalCode} `

  return (
    <div className={`${BASE_CLASS_NAME}-recommendedVehicleCard`}>
      <div className={`${BASE_CLASS_NAME}-recommendedVehicleCardContainer`}>
        <div className={`${BASE_CLASS_NAME}-recommendedVehicleCardImage`}>
          {isDesktop && (
            <img
              src={`${urlInstantOfferImages}vehicle.svg`}
              alt={i18n.t('LANDING_VEHICLE_APPRAISER.RECOMMENDED_PRICE_CARD.IMAGE_ALT_TEXT')}
              height={90}
            />
          )}
        </div>
        <div className={`${BASE_CLASS_NAME}-recommendedVehicleCardInfo`}>
          {!hasRecommendedPriceError && !c2bAppraisal && (
            <span className={`${BASE_CLASS_NAME}-recommendedVehicleCardInfoPrice`}>
              {i18n.c(roundedRecommendPrice)}
            </span>
          )}

          <h3>{vehicleName}</h3>
          <p>{vehicleInformation}</p>

          {!hasRecommendedPriceError && (
            <>
              <p>
                {htmlStringToReactElement(
                  i18n.t('LANDING_VEHICLE_APPRAISER.RECOMMENDED_PRICE_CARD.NEW_VEHICLE_PRICE', {
                    year,
                    highlightStart: '<strong>',
                    highlightEnd: '</strong>',
                    manufacturerPrice: i18n.c(manufacturerPrice)
                  })
                )}
              </p>
              {!c2bAppraisal && (
                <p>
                  {htmlStringToReactElement(
                    i18n.t('LANDING_VEHICLE_APPRAISER.APPRAISAL.BASED_ON_STANDARD_VERSION', {
                      highlightStart: '<strong>',
                      highlightEnd: '</strong>'
                    })
                  )}
                </p>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  )
}

RecommendedPriceCard.displayName = 'RecommendedPriceCard'
RecommendedPriceCard.propTypes = {
  fuelId: PropTypes.string.isRequired,
  km: PropTypes.string.isRequired,
  postalCode: PropTypes.string.isRequired,
  versionName: PropTypes.string.isRequired,
  year: PropTypes.string.isRequired,
  manufacturerPrice: PropTypes.number.isRequired,
  roundedRecommendPrice: PropTypes.number,
  hasRecommendedPriceError: PropTypes.bool,
  makeName: PropTypes.string.isRequired,
  modelName: PropTypes.string.isRequired,
  c2bAppraisal: PropTypes.object
}
export default RecommendedPriceCard
